(function(){

    angular.module('tmx-app').controller('loanRepaymentCtrl', ['$mdDialog', '$state', 'LoanApplicationService', 'LoanProductService',
        'lookupService', '$mdSidenav', 'resolvedData', 'tmxUtility', 'menu', 'tmxResource', 'TmxDialogService', 'ToastService', '$filter', 'TMX_FINANCE_CONSTANTS', 'cacheStore',
        function LoanRepaymentCtrl($mdDialog, $state, LoanApplicationService, LoanProductService,
            lookupService, $mdSidenav, resolvedData, tmxUtility, menu, tmxResource, TmxDialogService, ToastService, $filter, TMX_FINANCE_CONSTANTS, cacheStore) {

            //#region ------- Dev Notes ------------------

            //#endregion

            //#region --- Variable Declaration & Initialization--------
            var vm = this;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            vm.formatDate = tmxUtility.formatDateForCompany;
            vm.formatDateTime = tmxUtility.formatDateTimeForCompany;
            vm.checkPermission = tmxUtility.checkPermission;
            vm.menu = menu;

            vm.gridData = new kendo.data.ObservableArray([]);
            vm.date = new Date().toJSON();
            vm.cols = LoanApplicationService.filterColumn;
            vm.nav = "SearchSideNav";
            vm.schema = LoanApplicationService.schema;
            vm.cloneColumn = LoanApplicationService.gridColumn;
            vm.LoanApplicationService = LoanApplicationService;
            vm.gridColumns = LoanApplicationService.repaymentGridColumns;
            vm.filterColumns = LoanApplicationService.repaymentFilterColumns;
            var LoanApplicationStatus = resolvedData.LoanStatus;

            vm.editPermission = vm.checkPermission('Private.Transaction.LoanRepayment', "Edit");
            vm.filterChips = [];
            vm.selectedApplicationList = [];
            vm.applicationChecked = applicationChecked;
            var previousSelectedChip = null;
            

            //#endregion


            //#region ----- Local Functions-----------

            function InitializeGrid() {
                vm.filters = {};
                vm.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function (o) {

                                if (angular.isDefined(vm.searchClear) && vm.searchClear == false) {
                                    if (exists(vm.o)) {
                                        copy(vm.o.data, ["filter"], o.data);
                                    }
                                }
                                vm.searchClear = false;
                                if (vm.onChildState()) { return; }
                                if (!o.fromSideNav) {
                                    if ($state.searchClear) {
                                        vm.searchClear = true;
                                        $state.searchClear = undefined;
                                    }
                                }
                                else {
                                    o.data.firstPage = true;
                                }

                                vm.o = angular.copy(o);
                                vm.filters = vm.o.data.filter;
                                
                                tmxResource("LoanApplication/GetPaymentsList").getByParams(o, true).then(function (response) {
                                    vm.exportData = response;
                                    o.success(response);
                                });
                            },

                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },

                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        sort: [{ field: "loanRepaymentDetailId", dir: "desc" }]
                    },
                    excelExport: function (e) {
                        var sheet = e.workbook.sheets[0];
                        var data = vm.exportData.data;

                        var gridColumns = vm.container.LoanApplicationGrid.columns;
                        var filteredColumns = filterdColumns(gridColumns);
                        var columns = tmxUtility.columnsMapping(filteredColumns);
                        var rows = tmxUtility.dataMapping(data, columns);
                        sheet.rows = rows;
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: true,
                        pageSize: 10,
                        buttonCount: 5,
                    },
                    pdf: {
                        allPages: true,
                        fileName: "LoanRepayment.pdf"
                    },
                    excel: {
                        /*  allPages: true,*/
                        fileName: "LoanRepayment.xlsx"
                    },

                    sortable: true,
                    scrollable: false,
                    columns: vm.gridColumns
                };


                vm.searchSideNavActive = false;
                vm.container = {};//defining the object for grid access in controller
                $state.data = {
                    grid: vm.container,
                    mainGridOptions: angular.copy(vm.mainGridOptions)
                };
            }


            function filterdColumns(gridColumns) {
                var columns = [];
                gridColumns.map(function (col) {
                    columns.push(col);
                });
                return columns;
            }
            function PrepareLovs() {
                vm.TransactionStatusLkp = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.TransactionStatus);
                PrepareFilterChips();
            }
            function PrepareFilterChips() {
                let roleStatusLookups = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ROLE_STATUS_MAPPING);
                let loggedinUserInfo = cacheStore.get('GetInfoOfLoggedInUser');
                if (!exists(loggedinUserInfo)) {
                    return;
                }
                let roleStatusMappingItem = roleStatusLookups.find(x => x.HiddenValue.toLowerCase() == loggedinUserInfo.RoleName.toLowerCase());
                if (!exists(roleStatusMappingItem)) {
                    return;
                }
                vm.filterChips = roleStatusMappingItem.Description.split(',').map(x => ({ Name: x.trim(), Style: 'default' }));
                if (vm.filterChips.length > 0) {
                    vm.filterChips.unshift({ Name: 'All', Style: 'active' }); // Add 'All' on the begining of the array
                    previousSelectedChip = 'All';
                }
            }
            //#endregion

            //#region  -------- Scope Functions -----------


            vm.getMenu = function () {
                if (angular.isDefined(menu.pages.sections)) {
                    for (var i = 0; i < menu.pages.sections.length; i++) {
                        var section = menu.pages.sections[i];
                        if (angular.isDefined(section.pages) && section.pages != null && section.pages.length > 0) {
                            for (var j = 0; j < section.pages.length; j++) {
                                if (section.pages[j].name == vm.EntityName) {
                                    return section.pages[j];
                                }
                            }
                        }
                    }
                }
                return undefined;
            };
            vm.showProcessDiagram = function (dataitem) {
                switch (dataitem.Status) {

                case "Ready For Verification":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Review.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;


                case "Approved":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Loan Approved.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;


                case "Need More Clarification":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Draft.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;


                case "Re Verify Application":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Verification.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;


                case "Verified":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Review.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;


                case "Completed":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Completed.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;


                case "Ready For Approval":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Verification.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;


                case "Draft":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Draft.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;

                case "Rejected":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Loan Rejected.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;

                default:
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                            '<form ng-cloak>' +
                            ' <md-dialog-content> ' +
                            '<div class="md-dialog-content">' +
                            ' <img style="margin: auto; max-width: 100%;"  src="assets/images/NoHighlightedState.png">' +
                            '</div> ' +
                            '</md-dialog-content>' +
                            '</form></md-dialog>',
                        clickOutsideToClose: true,
                    });
                    break;

                }

            }
            vm.getLookupName = function (ApplicationStatusLkpId) {
                var result = "N/A";
                if (!angular.isArray(LoanApplicationStatus)) {
                    return result;
                }
                LoanApplicationStatus.forEach(function (loanAppStatusLookup) {

                    if (loanAppStatusLookup.HiddenValue == ApplicationStatusLkpId) {
                        result = loanAppStatusLookup.VisibleValue;
                    }
                });
                return result;
            }

            vm.gotoAdd = function (productId, branchId) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name + ".add", { Id: productId, branchId: branchId, callbackState: $state.current.name });
            }

            vm.onChildState = function () {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            }

            vm.goToEdit = function (application) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                var id = application.LoanApplicationId;
                $state.go($state.current.name + ".edit", { Id: id, callbackState: $state.current.name });
            }
            vm.goToEditId = function (id) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name + ".edit", { Id: id, callbackState: $state.current.name });
            }


            vm.isOpen = function (navID) {
                return $mdSidenav(navID).isOpen();
            };

            vm.clickSave = function () {
                var selectedStatus = vm.TransactionStatusLkp.filter(x=> x.LookupId == vm.PaymentsStatus)[0].VisibleValue;
                let messageText = 'Are you sure you want to update selected Payments status to <b>' + selectedStatus + '<b>?';
                let messageTitle = `Update Payments Status ?`
                TmxDialogService.showConfirmDialog(messageTitle, messageText, updatePaymentStatus);
                function updatePaymentStatus() {
                    tmxResource('LoanApplication').getByAction('UpdatePaymentsStatus/' + vm.PaymentsStatus, false, 'put', vm.selectedApplicationList).then(function (response) {
                        if(response && response.status && response.status.code == 200) {
                            ToastService.showCustomToast('success', 'Payments Status updated successfully');
                        }
                        else {
                            ToastService.showCustomToast('error', 'Something went wrong. Please see logs for details.');
                        }
                        vm.selectedApplicationList = [];
                        $('#grid').data('kendoGrid').dataSource.read();
                    });
                }
            };

            vm.clickAssign = function (item) {

                LoanProductService.getStatesbyProduct(item.LoanProductId).then(function (response) {

                    $mdDialog.show({
                        controller: ['$mdDialog', '$scope', 'tmxUtility', 'lookupService', 'TMX_FINANCE_CONSTANTS', 'data', 'states', assignController],
                        locals: {
                            data: item,
                            states: response.data
                        },
                        templateUrl: 'app/private/transaction/assign-dialog.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        fullscreen: true
                    }).then(function (returnData) { // After closing the dialog
                        if (!tmxUtility.exists(returnData)) {
                            return;
                        }
                        let data = returnData;
                        data.PreviousStatusLkp = item.ApplicationStatusLkp;
                        data.ProcessId = item.ProcessInstanceID;
                        data.ApplicationId = item.LoanApplicationId;
                        LoanApplicationService.setApplicationState(data).then(function (result) {
                            if (result.data && result.status.code == "200" && result.data.Success == true) {
                                ToastService.showCustomToast("success", $filter('translate')("StateChangeSuccess"));
                                $('#grid').data('kendoGrid').dataSource.read();
                                return;
                            }
                            ToastService.showCustomToast("error", $filter('translate')("StateChangeError"));
                        });

                    }, function () {

                    });
                });
            }

            vm.onChipClick = function (selectedChip) {
                if (previousSelectedChip == selectedChip.Name) {
                    return;
                }
                previousSelectedChip = selectedChip.Name;
                vm.filterChips.forEach(x => x.Style = 'default');
                selectedChip.Style = 'active';

                // if (exists(vm.o.data.filter)) {
                //     // If there is previous filter applied then remove the 'Status' Filter
                //     vm.o.data.filter.filters = vm.o.data.filter.filters.filter(x => x.field != 'Status');
                // }
                // else {
                    //Initialize the filters
                vm.o.data.filter = {
                    filters: [],
                    logic: 'and'
                }
                //}
                if (selectedChip.Name.toLowerCase() != 'all') {
                    var chipFilter = {
                        field: 'Status',
                        operator: 'contains',
                        value: selectedChip.Name
                    }
                    vm.o.data.filter.filters.push(chipFilter);
                }
                vm.container.LoanApplicationGrid.dataSource.transport.read(vm.o);
            }


            vm.formatDateTime = function (dateObj) {
                return tmxUtility.formatDateSpecific(dateObj, "DD/MMM/YYYY hh:mma");
            }

            vm.formatDate = function (dateObj) {
                console.log(dateObj);
                return tmxUtility.formatDateSpecific(dateObj, "DD-MMM-YYYY");
            }

            //*******************KENDO*********************//            
            vm.isFiltered = function (fieldName) {
                var filtered = false;
                if (angular.isDefined(vm.filters)) {
                    vm.filters.filters.forEach(function (filter) {
                        if (filter.field == fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }

            vm.formatString = function (value) {
                if (!value) {
                    return "N/A";
                }
                else {
                    return value;
                }
            };

            
            vm.toggleSearch = function () {
                if (vm.searchSideNavActive) {
                    vm.searchData = {};
                    vm.searchSideNavActive = false;
                }
                else
                    vm.searchSideNavActive = true;
                vm.toggle('SearchSideNav');
            }
            vm.exportSideNavActive = false;

            vm.toggleExport = function () {
                if (vm.exportSideNavActive)
                    vm.exportSideNavActive = false;
                else
                    vm.exportSideNavActive = true;
                vm.toggle('ExportSideNav');
            }

            vm.toggle = function (navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                    });
            };

            vm.search = function (navID) {

                let calls = [];
                for (var key in vm.searchData) {
                    if (vm.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: vm.searchData[key]
                        });
                    }
                }
                console.error(calls);

                vm.filt = {
                    filters: calls,
                    logic: "and"
                };
                vm.o.data.filter = vm.filt;
                vm.container.LoanApplicationGrid.dataSource.transport.read(vm.o);
                vm.searchData = {};
                vm.toggle(navID);
            };

            vm.clear = function (navID) {
                vm.searchData = {};
                vm.toggle(navID);
            };


            vm.formatAmount = function (Amount) {
                var amt = parseInt(Amount) || 0;
                return amt.toLocaleString();
            }

            vm.formatTenure = function (Tenure) {
                if (parseInt(Tenure, 10) <= 0) {
                    return "N/A";
                }
                else {
                    return Tenure;

                }
            }
            //#endregion

            //#region  --Child Controllers-----

            function assignController($mdDialog, $scope, tmxUtility, lookupService, TMX_FINANCE_CONSTANTS, data, states) {

                $scope.availableStates = [];
                $scope.availableStatuses = [];
                $scope.data = data;
                $scope.showLoanEditableFields = false;

                $scope.ok = function () {

                    $scope.assignDialogCtrl.dialogForm.$submitted = true;
                    if (!$scope.assignDialogCtrl.dialogForm.$valid) {
                        return;
                    }
                    let returnData = {
                        State: $scope.selectedState,
                        ApplicationStatusLkp: $scope.selectedStatus,
                        Comments: $scope.comments
                    }
                    $mdDialog.hide(returnData);
                }

                $scope.cancel = function () {
                    $mdDialog.hide();
                }

                function InitializeData() {
                    if (tmxUtility.exists(states) && states.length > 0) {
                        $scope.availableStates = states.filter(x => x.Name.trim() != "")
                            .map(x => ({
                                HiddenValue: x.Name,
                                VisibleValue: x.VisibleName
                            }));
                    }

                    $scope.availableStatuses = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.APPLICATION_STATUS);

                    $scope.availableStates = tmxUtility.orderArrayByProperty($scope.availableStates, ['VisibleValue'], ['asc']);
                    $scope.availableStatuses = tmxUtility.orderArrayByProperty($scope.availableStatuses, ['VisibleValue'], ['asc']);

                }

                (function InitializePage() {
                    InitializeData();
                })();
            }

            function applicationChecked(dataItem) {
                if (dataItem.Selected) {

                    vm.selectedApplicationList.push(
                        dataItem.LoanRepaymentDetailId
                    );
                }
                else {
                    var indexOfObj = vm.selectedApplicationList.findIndex(x => x == dataItem.LoanRepaymentDetailId);
                    vm.selectedApplicationList.splice(indexOfObj, 1);
                }

            }

            //#endregion


            // eslint-disable-next-line no-unexpected-multiline
            (function InitializePage() {
                InitializeGrid();
                PrepareLovs();
            })();

        }
    ]);
           
      
})();
